import React, { useCallback, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Image } from '../Image/Image'
import { Audio } from '../Audio/Audio'

import checkAudio from './check.mp3'
import styles from './Button.module.scss'


function Button({ muted, isNeedRegisterResource, src, className, audio, onClick }) {
    const audioRef = useRef(null)

    const onClickCallback = useCallback(() => {
        onClick()

        if (audioRef.current) {
            audioRef.current.play()
        }
    }, [audioRef, onClick])

    return (
        <>
            <Image
                isNeedRegisterResource={isNeedRegisterResource}
                src={src}
                className={classNames(styles.button, className)}
                onClick={onClickCallback}
            />

            {
                muted
                    ? null
                    : <Audio audioRef={audioRef} src={audio || checkAudio} />
            }
        </>
    )
}

Button.propTypes = {
    muted: PropTypes.bool,
    isNeedRegisterResource: PropTypes.bool,
    src: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    audio: PropTypes.any,
}

export { Button }
